var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1452_20690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.752 1.87988H10.127V0.879883C10.127 0.811133 10.0707 0.754883 10.002 0.754883H9.12695C9.0582 0.754883 9.00195 0.811133 9.00195 0.879883V1.87988H5.00195V0.879883C5.00195 0.811133 4.9457 0.754883 4.87695 0.754883H4.00195C3.9332 0.754883 3.87695 0.811133 3.87695 0.879883V1.87988H1.25195C0.975391 1.87988 0.751953 2.10332 0.751953 2.37988V12.7549C0.751953 13.0314 0.975391 13.2549 1.25195 13.2549H12.752C13.0285 13.2549 13.252 13.0314 13.252 12.7549V2.37988C13.252 2.10332 13.0285 1.87988 12.752 1.87988ZM12.127 12.1299H1.87695V6.19238H12.127V12.1299ZM1.87695 5.12988V3.00488H3.87695V3.75488C3.87695 3.82363 3.9332 3.87988 4.00195 3.87988H4.87695C4.9457 3.87988 5.00195 3.82363 5.00195 3.75488V3.00488H9.00195V3.75488C9.00195 3.82363 9.0582 3.87988 9.12695 3.87988H10.002C10.0707 3.87988 10.127 3.82363 10.127 3.75488V3.00488H12.127V5.12988H1.87695Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1452_20690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.865b430f9e011d296f550b53e58e801b.svg";
export { ForwardRef as ReactComponent };